import React, { useEffect, Fragment, useState } from 'react';
import { QtcRenderer } from '@3plearning/question-components-library';
import { Box } from '@chakra-ui/react';
import { useSingleQuestion } from './hooks/use-single-question';

export const QtcPreview = () => {
  const { mutate: singleQuestion, isSuccess, data, status } = useSingleQuestion();
  const [conquestData, setConquestData] = useState(null);
  const [css, setCss] = useState({});

  useEffect(() => {
    import('./qtc-preview.scss').then((styles) => {
      setCss(styles.default);
    });
    singleQuestion();
  }, []);

  useEffect(() => {
    if (isSuccess) {
      setConquestData(data.data.nextQuestion.conquest);
    }
  }, [isSuccess]);

  return (
    <Box className={css['qtc-container']}>
      {
        conquestData ? (
          <QtcRenderer
            question={conquestData.questionVariant.questionItem.questionContent.content}
            callback={() => null}
          />
        ) : (
          <Fragment>
            {
              status === 'error' ? (
                'Error loading example!'
              ) : (
                'Loading example...'
              )
            }
          </Fragment>
        )
      }
    </Box>
  );
};
